(() => {
'use strict';
function initializeDemo() {
if (!document.querySelector('[data-spark-demo]')) return;
'use strict';
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const image=$('#gallery-image'), hero='assets/ff355.png';
const galleryVideo=$('#gallery-video');
const galleryThumbs=$$('[data-gallery]');
let galleryIndex=0;
function setGallery(button){
 galleryIndex=galleryThumbs.indexOf(button)+1;
 galleryThumbs.forEach(thumb=>thumb.classList.toggle('selected',thumb===button));
 const showVideo=button.dataset.galleryVideo==='true';
 galleryVideo.hidden=!showVideo;image.hidden=showVideo;
 if(showVideo){galleryVideo.muted=true;galleryVideo.play().catch(()=>{galleryVideo.hidden=true;image.hidden=false;});}
 else{galleryVideo.pause();image.src='assets/'+button.dataset.gallery;image.alt=button.querySelector('img').alt;}
} 
$$('[data-gallery]').forEach(b=>{b.addEventListener('pointerenter',()=>setGallery(b));b.addEventListener('focus',()=>setGallery(b));b.addEventListener('click',()=>setGallery(b));});
$$('[data-spark-gallery-step]').forEach(button=>button.addEventListener('click',()=>{
 galleryIndex=(galleryIndex+Number(button.dataset.sparkGalleryStep)+galleryThumbs.length+1)%(galleryThumbs.length+1);
 if(galleryIndex){setGallery(galleryThumbs[galleryIndex-1]);return;}
 galleryVideo.pause();galleryVideo.hidden=true;image.hidden=false;image.src=hero;image.alt='Yuzu Lemon Spark Tonic pouch';
 galleryThumbs.forEach(thumb=>thumb.classList.remove('selected'));
}));
let quantity=1,purchase='once',cart=[];
try{const saved=JSON.parse(localStorage.getItem('spark-product-cart')||'[]');if(Array.isArray(saved))cart=saved.filter(x=>typeof x.name==='string'&&Number.isInteger(x.quantity)&&x.quantity>0);}catch{}
function setQuantity(n){quantity=Math.max(1,Math.min(99,n));$('#quantity').value=quantity;$('#quantity').textContent=quantity;$('#quantity-minus').disabled=quantity===1;}setQuantity(1);
$('#quantity-plus').addEventListener('click',()=>setQuantity(quantity+1));$('#quantity-minus').addEventListener('click',()=>setQuantity(quantity-1));
$$('[data-purchase]').forEach(b=>b.addEventListener('click',()=>{purchase=b.dataset.purchase;$$('[data-purchase]').forEach(x=>{x.setAttribute('aria-pressed',x===b);x.classList.toggle('chosen',x===b);});$('#product-price').textContent=purchase==='subscription'?'$49.30':'$58';$('[data-nav-price]').textContent=$('#product-price').textContent;}));
const safe=s=>s.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function showCart(){const el=$('#cart-items');el.innerHTML=cart.length?cart.map((x,i)=>'<div class="cart-item"><span>'+safe(x.name)+' × '+x.quantity+(x.price?' — $'+(x.price*x.quantity).toFixed(2):'')+'</span><button data-remove="'+i+'">Remove</button></div>').join(''):'<p>Your cart is empty.</p>';if(!$('#cart-dialog').open)$('#cart-dialog').showModal();}
function add(name,price=null,count=1){cart.push({name,price,quantity:count});try{localStorage.setItem('spark-product-cart',JSON.stringify(cart));}catch{}showCart();}
$$('[data-add-main]').forEach(b=>b.addEventListener('click',()=>add('Yuzu lemon · 10 pack'+(purchase==='subscription'?' · Subscription':''),purchase==='subscription'?49.30:58,quantity)));
function info(title,copy,file){$('#info-title').textContent=title;$('#info-content').replaceChildren();if(file){const im=document.createElement('img');im.src='assets/'+file;im.alt=title;im.className='info-image';$('#info-content').append(im);}const p=document.createElement('p');p.textContent=copy;$('#info-content').append(p);$('#info-dialog').showModal();}
$$('[data-flavour="strawberry"]').forEach(b=>b.addEventListener('click',()=>info('Strawberry lemon','This preview contains the Yuzu Lemon page. Connect this option to the Strawberry Lemon product page in your store.')));
$$('[data-pack]').forEach(b=>b.addEventListener('click',()=>{if(b.dataset.pack!=='10')info(b.textContent,'This pack’s price and product destination were not supplied. Connect this option to its product variant in your store.');}));
const details=$$('.product-details details');details.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)details.forEach(other=>{if(other!==d)other.open=false;});}));
const originalIngredient=$('#ingredient-copy').textContent;
const ingredientData={
 yuzu:{title:'Yuzu',copy:originalIngredient,image:'0b731.png'},
 lemon:{title:'Lemon',copy:'The brief was lemon. That absolute, clean reset of cold water and a single sharp squeeze. Sophie wanted to bottle exactly that feeling.',image:'lemon-fruit.png'},
 electrolytes:{title:'Mg, K, Na'}
};
function chooseIngredient(b){
 const key=b.dataset.ingredient,item=ingredientData[key],panel=$('.ingredient-panel');
 if(panel.dataset.panel===key)return;
 panel.dataset.panel=key;$('#ingredient-title').textContent=item.title;
 $('.ingredient-body').hidden=key==='electrolytes';$('.ingredient-divider').hidden=key==='electrolytes';$('.ingredient-minerals').hidden=key!=='electrolytes';
 if(item.copy){$('#ingredient-copy').textContent=item.copy;$('#ingredient-fruit').src='assets/'+item.image;$('#ingredient-fruit').alt=item.title;}
 $$('[data-ingredient]').forEach(x=>x.setAttribute('aria-pressed',x===b));
 if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
  [$('#ingredient-title'),key==='electrolytes'?$('.ingredient-minerals'):$('.ingredient-body')].forEach(x=>x.animate([{opacity:0},{opacity:1}],{duration:250,easing:'ease-out'}));
 }
}
$$('[data-ingredient]').forEach(b=>{b.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')chooseIngredient(b);});b.addEventListener('click',()=>chooseIngredient(b));b.addEventListener('focus',()=>chooseIngredient(b));});
const track=$('.comparison-track'),dots=$$('[data-slide]');
function activeDot(i){dots.forEach((d,n)=>{d.setAttribute('aria-pressed',n===i);d.querySelector('img').src='assets/'+(n===i?'b5685.svg':n===2?'7456b.svg':'f72e1.svg');});}
dots.forEach((d,i)=>d.addEventListener('click',()=>{track.scrollTo({left:track.children[i].offsetLeft-track.children[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});activeDot(i);}));
track.addEventListener('scroll',()=>{const step=track.children[0].getBoundingClientRect().width+12;activeDot(Math.round(track.scrollLeft/step));},{passive:true});
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();const current=Math.round(track.scrollLeft/(track.children[0].getBoundingClientRect().width+12));dots[Math.max(0,Math.min(2,current+(e.key==='ArrowRight'?1:-1)))].click();}});
$('[data-story]').addEventListener('click',()=>info('Mr S(park)',$('.origin-copy p').textContent));
document.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.matches('[data-close],.close'))b.closest('dialog').close();if(b.dataset.add)add(b.dataset.add);if(b.dataset.product)info(b.dataset.product,'Clear, crisp and refreshingly light. Connect this card to its product page in your store.',b.dataset.image);if(b.dataset.remove!==undefined){cart.splice(Number(b.dataset.remove),1);try{localStorage.setItem('spark-product-cart',JSON.stringify(cart));}catch{}showCart();}});
$$('dialog:not([data-flavour-sheet])').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));

// Repeat the complete phrase group until each half covers the viewport.
// Translating by precisely one half then wraps to an identical frame.
const marquee=$('.marquee'),marqueeTrack=$('.marquee-track');
const marqueeItems=[...marqueeTrack.firstElementChild.children].map(n=>n.cloneNode(true));
let marqueeWidth=0;
function fitMarquee(){
 const width=marquee.clientWidth;if(!width||width===marqueeWidth)return;marqueeWidth=width;
 const group=marqueeTrack.firstElementChild;group.replaceChildren(...marqueeItems.map(n=>n.cloneNode(true)));
 const baseWidth=group.getBoundingClientRect().width;
 const copies=Math.max(1,Math.ceil((width+1)/baseWidth));
 for(let i=1;i<copies;i++)group.append(...marqueeItems.map(n=>n.cloneNode(true)));
 const twin=group.cloneNode(true);twin.setAttribute('aria-hidden','true');marqueeTrack.lastElementChild.replaceWith(twin);
 marqueeTrack.style.setProperty('--marquee-duration',(group.getBoundingClientRect().width/(1274/18))+'s');
}
new ResizeObserver(fitMarquee).observe(marquee);document.fonts.ready.then(()=>{marqueeWidth=0;fitMarquee();});fitMarquee();
// Keep decorative videos silent, pause off-screen, and respect reduced motion.
const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
const autoplayVideos=$$('video[autoplay]');
const videoObserver=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{
 target.dataset.inView=String(isIntersecting);target.muted=true;
 if(isIntersecting&&!motionPreference.matches&&!document.hidden)target.play().catch(()=>{});else target.pause();
}));autoplayVideos.forEach(v=>videoObserver.observe(v));
function updateVideoPlayback(){autoplayVideos.forEach(v=>{if(v.dataset.inView==='true'&&!motionPreference.matches&&!document.hidden)v.play().catch(()=>{});else v.pause();});}
motionPreference.addEventListener('change',updateVideoPlayback);document.addEventListener('visibilitychange',updateVideoPlayback);

}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDemo, { once: true });
else initializeDemo();
})();

// Shopify sections: real forms and variant links keep their native behavior.
(() => {
 'use strict';
 if (window.__sparkShopifySectionsInitialized) return;
 window.__sparkShopifySectionsInitialized = true;
 const instances = new WeakMap();
 const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 function initialize(root) {
  const sections = [...root.querySelectorAll('[data-spark-product], [data-spark-ingredients], [data-spark-marquee], [data-spark-comparison]')];
  if (root.matches?.('[data-spark-product], [data-spark-ingredients], [data-spark-marquee], [data-spark-comparison]')) sections.unshift(root);
  sections.forEach(section => {
   if (instances.has(section)) return;
   const controller = new AbortController();
   const cleanups = [];
   const on = (el, event, callback) => el?.addEventListener(event, callback, { signal: controller.signal });
   instances.set(section, () => { controller.abort(); cleanups.forEach(fn => fn()); instances.delete(section); });
   if (section.matches('[data-spark-product]')) {
    const choices = [...section.querySelectorAll('input[name="selling_plan"][data-spark-plan-price]')];
    const quantityInput = section.querySelector('form input[name="quantity"]');
    const summary = section.querySelector('[data-spark-quantity-summary]');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
     style:'currency', currency:section.dataset.sparkCurrency || 'USD', currencyDisplay:'narrowSymbol'
    }).format(cents / 100);
    const updatePlan = () => {
     const selected = choices.find(input => input.checked);
     const price = section.querySelector('[data-spark-price]');
     const unit = section.querySelector('[data-spark-unit-price]');
     const compare = section.querySelector('[data-spark-compare]');
     // Older section markup keeps its original unit-price behavior.
     if (!summary) {
      if (!selected) return;
      if (price) price.textContent = selected.dataset.sparkPlanPrice;
      if (unit) unit.textContent = selected.dataset.sparkPlanUnit;
      if (compare) { compare.textContent = selected.dataset.sparkPlanCompare || ''; compare.hidden = !selected.dataset.sparkPlanCompare; }
      return;
     }
     const quantity = quantityInput?.valueAsNumber;
     if (!Number.isInteger(quantity) || quantity < 1 || !quantityInput.validity.valid) return;
     const cents = Number(selected?.dataset.sparkPlanCents ?? section.dataset.sparkBasePrice);
     if (!Number.isFinite(cents)) return;
     // These automatic discounts apply only to collection 519253950745.
     // The best tier wins; subscription allocations are the starting price.
     const discount = section.dataset.sparkQuantityDiscounts === 'true' ? (quantity >= 4 ? 16 : quantity >= 2 ? 8 : 0) : 0;
     const totalCents = amount => Math.round(amount * quantity * (100 - discount) / 100);
     const total = money(totalCents(cents));
     if (price) price.textContent = total;
     if (unit && selected) unit.textContent = selected.dataset.sparkPlanUnit;
     if (compare) {
      const compareCents = Math.max(Number(selected?.dataset.sparkCompareCents || 0), discount ? cents : 0);
      compare.hidden = compareCents * quantity <= totalCents(cents);
      compare.textContent = !compare.hidden ? money(compareCents * quantity) : '';
     }
     choices.forEach(choice => {
      const output = choice.closest('label')?.querySelector('[data-spark-choice-total]');
      const amount = Number(choice.dataset.sparkPlanCents);
      if (output && Number.isFinite(amount)) output.textContent = money(totalCents(amount));
     });
     const pouches = Math.max(1, Math.trunc(Number(section.dataset.sparkPouchesPerPack) || 10));
     summary.textContent = `${quantity} ${quantity === 1 ? 'pack' : 'packs'} · ${quantity * pouches} pouches · ${total}`;
     const note = section.querySelector('[data-spark-discount-note]');
     if (note) {
      note.hidden = !discount;
      note.textContent = discount ? `${discount}% quantity discount${selected?.value ? ' on first subscription payment' : ''} · Estimated total; final discount calculated in cart.` : '';
     }
    };
    choices.forEach(input => on(input, 'change', updatePlan));
    on(quantityInput, 'input', updatePlan); on(quantityInput, 'change', updatePlan); updatePlan();
    section.querySelectorAll('[data-spark-quantity]').forEach(control => {
     const input = control.querySelector('input[name="quantity"]');
     const minus = control.querySelector('[data-quantity-minus]');
     const plus = control.querySelector('[data-quantity-plus]');
     if (!input || !minus || !plus) return;
     const sync = () => {
      const value = input.valueAsNumber;
      const min = Number(input.min || 1);
      const max = input.max === '' ? Infinity : Number(input.max);
      minus.disabled = !Number.isFinite(value) || value <= min;
      plus.disabled = !Number.isFinite(value) || value >= max;
     };
     const step = direction => {
      if (direction > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
     };
     on(minus, 'click', () => step(-1));
     on(plus, 'click', () => step(1));
     on(input, 'input', sync); on(input, 'change', sync); sync();
    });
    // Pack size is a quantity shortcut for the current product, not a variant change.
    const packInput = section.querySelector('form input[name="quantity"]');
    const packButtons = [...section.querySelectorAll('[data-spark-pack-quantity]')];
    if (packInput && packButtons.length) {
     const syncPacks = () => {
      const min = Number(packInput.min || 1);
      const max = packInput.max === '' ? Infinity : Number(packInput.max);
      const step = Number(packInput.step || 1);
      packButtons.forEach(button => {
       const quantity = Number(button.dataset.sparkPackQuantity);
       const valid = Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
       const selected = valid && packInput.valueAsNumber === quantity;
       button.disabled = !valid;
       button.classList.toggle('selected', selected);
       button.setAttribute('aria-pressed', String(selected));
      });
     };
     packButtons.forEach(button => on(button, 'click', () => {
      if (button.disabled) return;
      packInput.value = button.dataset.sparkPackQuantity;
      packInput.dispatchEvent(new Event('input', { bubbles: true }));
      packInput.dispatchEvent(new Event('change', { bubbles: true }));
     }));
     on(packInput, 'input', syncPacks);
     on(packInput, 'change', syncPacks);
     syncPacks();
    }
    const gallery = section.querySelector('[data-spark-gallery]');
    if (!gallery) return;
    const media = [...gallery.children].filter(el => el.matches('img, video, iframe, model-viewer'));
    const initial = media.find(el => !el.hidden) || media[0];
    const links = [...section.querySelectorAll('[data-spark-media-target]')];
    let active = initial;
    const show = target => {
     if (!target) return;
     active = target;
     media.forEach(el => {
      el.hidden = el !== target;
      if (el.matches('video')) {
       if (el === target && !reduced()) { el.muted = true; el.play().catch(() => {}); }
       else el.pause();
      }
      if (el.matches('iframe') && el !== target && el.dataset.sparkWasActive === 'true') {
       // Unload playback when leaving an external-video slide.
       const src = el.getAttribute('src'); el.setAttribute('src', src);
      }
      el.dataset.sparkWasActive = String(el === target);
     });
     links.forEach(link => {
      const selected = link.hash === '#' + target.id;
      link.classList.toggle('selected', selected);
      if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
     });
    };
    links.forEach(link => {
     const target = media.find(el => '#' + el.id === link.hash);
     on(link, 'click', event => { if (target) { event.preventDefault(); show(target); } });
     on(link, 'pointerenter', event => { if (event.pointerType === 'mouse') show(target); });
     on(link, 'focus', () => show(target));
    });
    section.querySelectorAll('[data-spark-gallery-step]').forEach(button => {
     button.hidden = media.length < 2;
     on(button, 'click', () => {
      if (media.length < 2) return;
      const index = (media.indexOf(active) + Number(button.dataset.sparkGalleryStep) + media.length) % media.length;
      show(media[index]);
     });
    });
    show(initial);
   }
   if (section.matches('[data-spark-ingredients]')) {
    const container = section.querySelector('.ingredient-panel');
    const panels = [...section.querySelectorAll('[data-spark-ingredient-panel]')];
    const links = [...section.querySelectorAll('[data-spark-ingredient-target]')];
    const show = id => {
     const active = panels.find(panel => panel.dataset.sparkIngredientPanel === id);
     if (!active || !container) return;
     container.dataset.panel = active.dataset.panel;
     panels.forEach(panel => { panel.hidden = panel !== active; });
     links.forEach(link => {
      const selected = link.dataset.sparkIngredientTarget === id;
      link.classList.toggle('selected', selected);
      if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
     });
    };
    links.forEach(link => {
     on(link, 'click', event => { event.preventDefault(); show(link.dataset.sparkIngredientTarget); });
     on(link, 'pointerenter', event => { if (event.pointerType === 'mouse') show(link.dataset.sparkIngredientTarget); });
     on(link, 'focus', () => show(link.dataset.sparkIngredientTarget));
    });
    on(section, 'shopify:block:select', event => show(event.detail.blockId));
    const initial = panels.find(panel => panel.dataset.panel === (container?.dataset.initialState || 'yuzu')) || panels[0];
    if (initial) show(initial.dataset.sparkIngredientPanel);
   }
   if (section.matches('[data-spark-comparison]')) {
    const track = section.querySelector('.comparison-track');
    const cards = [...section.querySelectorAll('.comparison-card')];
    const dots = [...section.querySelectorAll('[data-spark-compare-index]')];
    if (!track || !cards.length) return;
    const mark = index => dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    const activeIndex = () => {
     let index = 0, distance = Infinity;
     cards.forEach((card, i) => {
      const delta = Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft);
      if (delta < distance) { distance = delta; index = i; }
     });
     return index;
    };
    const go = index => {
     const bounded = Math.max(0, Math.min(cards.length - 1, index));
     track.scrollTo({left: cards[bounded].offsetLeft - cards[0].offsetLeft, behavior: reduced() ? 'instant' : 'smooth'});
     mark(bounded);
    };
    dots.forEach((dot, index) => on(dot, 'click', () => go(index)));
    on(track, 'scroll', () => mark(activeIndex()));
    on(track, 'keydown', event => {
     if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); go(activeIndex() + (event.key === 'ArrowRight' ? 1 : -1));
     }
    });
    const observer = new ResizeObserver(() => mark(activeIndex())); observer.observe(track);
    cleanups.push(() => observer.disconnect()); mark(activeIndex());
   }
   if (section.matches('[data-spark-marquee]')) {
    const track = section.querySelector('.marquee-track');
    const group = track?.firstElementChild;
    if (!group?.children.length) return;
    const originals = [...group.children].map(el => el.cloneNode(true));
    const fit = () => {
     group.replaceChildren(...originals.map(el => el.cloneNode(true)));
     const width = group.getBoundingClientRect().width;
     if (!width) return;
     const copies = Math.max(1, Math.ceil((section.clientWidth + 1) / width));
     for (let i = 1; i < copies; i++) group.append(...originals.map(el => el.cloneNode(true)));
     const twin = group.cloneNode(true); twin.setAttribute('aria-hidden', 'true');
     twin.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
     if (track.children.length > 1) track.lastElementChild.replaceWith(twin); else track.append(twin);
     track.style.setProperty('--marquee-duration', (group.getBoundingClientRect().width / (1274 / 18)) + 's');
    };
    const observer = new ResizeObserver(fit); observer.observe(section); cleanups.push(() => observer.disconnect());
    document.fonts?.ready.then(() => { if (!controller.signal.aborted) fit(); }); fit();
   }
  });
 }
 const start = () => initialize(document);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 document.addEventListener('shopify:section:unload', event => {
  [event.target, ...event.target.querySelectorAll('[data-spark-product], [data-spark-ingredients], [data-spark-marquee], [data-spark-comparison]')].forEach(el => instances.get(el)?.());
 });
})();

// One sticky control forwards to the original purchase button and its form.
(() => {
 if (window.__sparkStickyPurchaseInitialized) return;
 window.__sparkStickyPurchaseInitialized = true;
 const instances = new Map();
 function initialize(root) {
  const sections = [...root.querySelectorAll('[data-spark-sticky-root]')];
  if (root.matches?.('[data-spark-sticky-root]')) sections.unshift(root);
  sections.forEach(section => {
   if (instances.has(section)) return;
   const bar = section.querySelector('[data-spark-sticky-bar]');
   const original = section.querySelector('.cart-row button[name="add"], .cart-row [data-add-main]');
   const button = bar?.querySelector('[data-spark-sticky-add]');
   if (!bar || !original || !button) return;
   const controller = new AbortController();
   const trigger = section.querySelector('[data-flavour-open]');
   const sheet = section.querySelector('[data-flavour-sheet]');
   const mobile = window.matchMedia('(max-width: 760px)');
   let closingTimer;
   const finishClose = () => {
    clearTimeout(closingTimer);
    if (!sheet?.open) return;
    sheet.close(); sheet.removeAttribute('data-closing'); trigger?.setAttribute('aria-expanded', 'false');
    if (!bar.hidden && mobile.matches) trigger?.focus({ preventScroll: true });
   };
   const closeSheet = () => {
    if (!sheet?.open || sheet.hasAttribute('data-closing')) return;
    sheet.setAttribute('data-closing', '');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishClose();
    else closingTimer = setTimeout(finishClose, 250);
   };
   trigger?.addEventListener('click', () => {
    if (!sheet || sheet.open) return;
    sheet.showModal(); trigger.setAttribute('aria-expanded', 'true');
   }, { signal: controller.signal });
   sheet?.querySelector('[data-flavour-close]')?.addEventListener('click', closeSheet, { signal: controller.signal });
   sheet?.addEventListener('cancel', event => { event.preventDefault(); closeSheet(); }, { signal: controller.signal });
   sheet?.addEventListener('click', event => {
    if (event.target === sheet) {
     const rect = sheet.getBoundingClientRect();
     if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) closeSheet();
    }
    if (event.target.closest('[aria-current="page"]')) { event.preventDefault(); closeSheet(); }
   }, { signal: controller.signal });
   mobile.addEventListener('change', () => { if (!mobile.matches) finishClose(); }, { signal: controller.signal });
   // The standalone HTML has only Yuzu product data; reuse its existing flavour preview.
   section.querySelectorAll('[data-demo-flavour]').forEach(option => option.addEventListener('click', () => {
    finishClose();
    if (option.dataset.demoFlavour === 'strawberry') document.querySelector('.flavour-options [data-flavour="strawberry"]')?.click();
   }, { signal: controller.signal }));
   const spacer = document.createElement('div');
   spacer.className = 'spark-sticky-spacer'; spacer.hidden = true;
   spacer.setAttribute('aria-hidden', 'true'); document.body.append(spacer);
   const sync = () => {
    const label = original.textContent.trim();
    if (button.dataset.label !== label) {
     const text = document.createElement('span'); text.textContent = label; button.replaceChildren(text);
     button.dataset.label = label; button.setAttribute('aria-label', label);
    }
    button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.getAttribute('aria-busy') === 'true';
   };
   const visibility = () => {
    const visible = original.getBoundingClientRect().bottom <= 0;
    bar.hidden = !visible; spacer.hidden = !visible;
    if (!visible) finishClose();
   };
   button.addEventListener('click', () => { sync(); if (!button.disabled) original.click(); }, { signal: controller.signal });
   const observer = new MutationObserver(sync);
   observer.observe(original, { attributes: true, childList: true, subtree: true, characterData: true });
   const intersection = new IntersectionObserver(visibility);
   intersection.observe(original);
   window.addEventListener('pageshow', visibility, { signal: controller.signal });
   sync(); visibility();
   instances.set(section, () => { controller.abort(); finishClose(); clearTimeout(closingTimer); observer.disconnect(); intersection.disconnect(); spacer.remove(); bar.hidden = true; instances.delete(section); });
  });
 }
 const start = () => initialize(document);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 document.addEventListener('shopify:section:unload', event => {
  for (const [section, cleanup] of instances) if (section === event.target || event.target.contains(section)) cleanup();
 });
})();

// Scrollable thumbnail rail, shared by the HTML preview and Shopify sections.
(() => {
 if (window.__sparkThumbnailRails) return;
 window.__sparkThumbnailRails = true;
 const rails = new Map();
 let nextId = 0;
 const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 function initialize(root) {
  const tracks = [...root.querySelectorAll('.gallery .thumbnails')];
  tracks.forEach(track => {
   if (rails.has(track)) return;
   const controller = new AbortController();
   const wrapper = document.createElement('div');
   wrapper.className = 'spark-thumbnail-carousel';
   track.before(wrapper); wrapper.append(track);
   if (!track.id) track.id = `SparkThumbnailRail-${++nextId}`;
   track.setAttribute('aria-label', 'Product thumbnails');
   track.tabIndex = 0;
   const buttons = [-1, 1].map(direction => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `spark-thumbnail-arrow spark-thumbnail-arrow--${direction < 0 ? 'previous' : 'next'}`;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [name, value] of Object.entries({viewBox:'0 0 24 24', width:'24', height:'24', fill:'none', stroke:'currentColor', 'stroke-width':'1.5', 'aria-hidden':'true', focusable:'false'})) svg.setAttribute(name, value);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', direction < 0 ? 'M14 5l-7 7 7 7' : 'M10 5l7 7-7 7');
    svg.append(path); button.append(svg);
    button.setAttribute('aria-label', direction < 0 ? 'Previous thumbnails' : 'Next thumbnails');
    button.setAttribute('aria-controls', track.id);
    button.addEventListener('click', () => track.scrollBy({left:direction * track.clientWidth, behavior:reduced() ? 'instant' : 'smooth'}), {signal:controller.signal});
    wrapper.append(button);
    return button;
   });
   const sync = () => {
    const overflow = track.scrollWidth > track.clientWidth + 2;
    buttons.forEach(button => { button.hidden = !overflow; });
    buttons[0].disabled = track.scrollLeft <= 2;
    buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
   };
   let selected = null;
   const reveal = () => {
    const current = track.querySelector('.thumb.selected, .thumb[aria-current="true"], .thumb[aria-pressed="true"]');
    if (!current || current === selected) return;
    selected = current;
    const rail = track.getBoundingClientRect(), item = current.getBoundingClientRect();
    const offset = item.left < rail.left ? item.left - rail.left : item.right > rail.right ? item.right - rail.right : 0;
    if (offset) track.scrollBy({left:offset, behavior:reduced() ? 'instant' : 'smooth'});
   };
   track.addEventListener('scroll', sync, {passive:true, signal:controller.signal});
   track.addEventListener('keydown', event => {
    if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault(); buttons[event.key === 'ArrowLeft' ? 0 : 1].click();
   }, {signal:controller.signal});
   const resize = new ResizeObserver(sync); resize.observe(track);
   const mutations = new MutationObserver(() => { sync(); reveal(); });
   mutations.observe(track, {subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-current','aria-pressed']});
   sync(); reveal();
   rails.set(track, () => { controller.abort(); resize.disconnect(); mutations.disconnect(); wrapper.before(track); wrapper.remove(); rails.delete(track); });
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
 else initialize(document);
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 document.addEventListener('shopify:section:unload', event => {
  for (const [track, cleanup] of rails) if (event.target.contains(track)) cleanup();
 });
})();
